import { useEffect, useState } from 'react';
import { getServices } from '../api';
import PageWrapper from '../components/PageWrapper';
import ServiceCard from '../components/ServiceCard';
import Loader from '../components/Loader';

export default function Services() {
  const [services, setServices] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getServices().then(setServices).catch(() => {}).finally(() => setLoading(false));
  }, []);

  return (
    <PageWrapper>
      <section className="section">
        <div className="container">
          <span className="eyebrow">What we offer</span>
          <h1 className="section-title">Services</h1>
          <p className="section-sub">End-to-end solutions crafted around your goals. Tap a service to read the full details.</p>

          {loading ? (
            <Loader />
          ) : services.length ? (
            <div className="grid grid-3">
              {services.map((s, i) => <ServiceCard key={s._id} service={s} index={i} />)}
            </div>
          ) : (
            <div className="empty">
              <div className="empty__icon">🧩</div>
              <h3>No services yet</h3>
            </div>
          )}
        </div>
      </section>
    </PageWrapper>
  );
}
